import React , {useState} from 'react'
import { useNavigate } from 'react-router-dom';
import './sec4.css';
import Event9 from '../../assets/Events/Posters/Event9.jpg';
import Event8 from '../../assets/Events/Posters/Event8.jpg';
import Event7 from '../../assets/Events/Posters/Event7.jpg';
import Eventimg9 from '../../assets/Events/Images/Eventimg9.jpg';
import Eventimg8 from '../../assets/Events/Images/Eventimg8.jpg';
import Eventimg7 from '../../assets/Events/Images/Eventimg7.jpg';
import { Link } from 'react-router-dom';
import { motion, setDragLock, transform } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const Datasets = [
  {
      title: 'DOWN THE MEMORY LANE ',
      poster: Event9,
      Date:'December 2023',
      Eventimg:Eventimg9,
      Description:'The 2000s nostalgia quiz.',
      text: 'Down the Memory Lane was a special 2000s nostalgia quiz jointly organized by QuizInc, NIT Durgapur, and the Quiz Club, NIT Warangal, through Instagram and Google Meet. The event took participants on a delightful journey back to the vibrant era of the 2000s, celebrating the golden days of entertainment. From iconic Bollywood blockbusters to unforgettable pop culture moments, the quiz covered everything that made the decade memorable. Trivia about hit movies, timeless songs, classic TV shows, and the defining stars of the era resonated with quiz enthusiasts, offering a fun and engaging platform to reminisce and relive the charm of the 2000s. With its unique theme and enthusiastic participation, Down the Memory Lane became a heartwarming tribute to a cherished decade, leaving everyone with a smile and a dose of nostalgia. ',
  },
  {
      title: 'BACK TO ORIGINS',
      poster: Event8,
      Date:'January 2024',
      Eventimg:Eventimg8,
      Description:'A quiz on the origin of internet trends and cultural practices.',
      text: "Back to Origins was an intriguing quiz focused on the origins of internet trends and cultural practices, jointly organized by QuizInc, NIT Durgapur, and Qunite, NIT Jamshedpur. Held virtually, this quiz took participants on a deep dive into the fascinating evolution of the internet and how various trends and cultural phenomena began, spread, and evolved over time. From viral challenges and memes to the rise of social media platforms, the quiz covered a wide range of topics that highlighted the cultural shifts shaped by the digital age. Engaging trivia about the early days of the internet and the cultural impact of these trends made the event an exciting journey of discovery. With its unique theme and enthusiastic participation, Back to Origins offered a fresh and insightful perspective on the ever-changing digital world, leaving participants with a deeper understanding of the internet's influence on modern culture.",
  },
  {
      title: 'HOWZZAT',
      poster: Event7,
      Date:'May 2024',
      Eventimg:Eventimg7,
      Description:'Annual cricket quiz organised by QuizInc.',
      text: 'Howzzat is the annual cricket quiz organized by QuizInc, NIT Durgapur, conducted through Instagram Stories and the final round on Google Meet. The event brings together cricket enthusiasts from across the country, testing their knowledge of the sport in a fun and engaging way. With questions ranging from historical milestones to current-day cricketing events, the quiz covers all aspects of the game, including iconic players, memorable matches, and legendary moments. The interactive nature of Instagram Stories allows participants to engage with the quiz in real-time, while the final round on Google Meet adds an exciting competitive edge, fostering a lively atmosphere. With passionate participation and thrilling questions, Howzzat has become a much-anticipated event, offering both a celebration of the sport and a platform for fans to showcase their cricket knowledge.',
  }
];

const Sec4 = () => {
  const [selectedContent, setSelectedContent] = useState(null);

  const [enable,setenable]=useState()
  const history=useNavigate()

  const handle = (item) => {
    history("/Eventdetails",{state:{data:item}})
  }
  const { ref, inView } = useInView({
    triggerOnce: false, 
    threshold: 0.1,    
  });

  const textVariant = {
    hidden: { opacity: 0, y: 90},
    visible: { opacity: 1, y: 0, transition: { duration: 0.9 } }
  };
  return (
    <div>
      <h1 style={{textAlign: "center", padding: "20px", fontSize:"3rem", fontWeight:"600"}}>Events so far</h1>
      <motion.div 
        className="events"
        ref={ref}
        initial="hidden"
        animate={inView ? 'visible' : 'hidden'}
        variants={textVariant}>
      {
        Datasets.map((item)=>{
            return (
                <div class="events-div">
                    <img src={item.poster} alt="event-img"/>
                    <h1 style={{textAlign: "center",fontSize: 20, fontWeight: 600, margin: 0, width:290}}>{item.title}</h1>
                    <p style={{ textAlign: "center", height: "fit-content", overflow: "hidden", fontSize:"medium", width: 290, height:"50px"}}>{item.Description}</p>
                    <button onClick={()=>handle(item)} style={{textAlign: "center", textDecoration: "none", color: "#183883",fontSize:"medium", fontWeight: 500, width:290, border:"None", backgroundColor:"#FBE6E3", cursor:"pointer"}}>Read More</button>
                </div>
            )
        })
      }
      </motion.div>
      <div className="event-btn-container">
        <Link to="/Events">
          <div className="event-btn">
            <p className='viewMore-text'>View more events from us</p>        
          </div>
        </Link>
      </div>
      <div className="reach-us">
        <h1 style={{textAlign: "center", margin: 0, fontSize:"3rem", fontWeight:"600"}}>Reach Us</h1>
        <div className="reach-us-inside">
          <div className="reach-us-left">
            <h1 class="coordinator-h1" style={{fontSize:"x-large", fontWeight: 600, margin: 0}}>Faculty Advisors:</h1>
            <br/>
            <h3 style={{margin:0, fontSize: "medium", fontWeight: 500, lineHeight: 1}}>Dr. Joydeep Banerjee</h3>
            <h4 style={{margin:0, fontSize: "medium", fontWeight: 400, lineHeight: 1}}>(Dept. of HSS)</h4>
            <br/>
            <h3 style={{margin:0, fontSize: "medium", fontWeight: 500, lineHeight: 1}}>Dr. Parag Kumar Guhathakurta</h3>
            <h4 style={{margin:0, fontSize: "medium", fontWeight: 400, lineHeight: 1}}>(Dept. of CSE)</h4>
          </div>
          <div className="reach-us-right">
            <h1 class="coordinator-h1" style={{fontSize:"x-large", fontWeight: 600, margin: 0}}>Student Coordinators:</h1>
            <br/>
            <h3 style={{margin:0, fontSize: "medium", fontWeight: 500, lineHeight: 1}}>Ankan Kumar Kundu</h3>
            <h4 style={{margin:0, fontSize: "medium", fontWeight: 400, lineHeight: 1}}>+91 85838 11419</h4>
            <br/>
            <h3 style={{margin:0, fontSize: "medium", fontWeight: 500, lineHeight: 1}}>Anamitra Hazra</h3>
            <h4 style={{margin:0, fontSize: "medium", fontWeight: 400, lineHeight: 1}}>+91 82405 18231</h4>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Sec4